module.exports = __webpack_public_path__ + "static/media/BnF-Flats.810fc5c8.jpg";